export default __webpack_public_path__ + "static/media/034-punching bag.efc8aa02.svg";